import {Component, OnInit} from "@angular/core";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {Utils} from "../common/utils";

@Component({
    selector: 'dp-footer',
    templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit {

    currentYear: number;

    constructor() {

    }

    ngOnInit(): void {
        this.currentYear = Utils.currentYear();
    }

}